<template>
  <div class="slide-page">
    <NavBarM @jump="jump" ref="navbar"></NavBarM>
    <!-- 晋升通道 -->
    <div class="slide-content" ref="content">
      <div>
        <img
          style="height: 17rem; width: auto; margin: 0.3rem"
          src="../../assets/img/pc/talents.png"
          alt=""
        />
      </div>
    </div>
    <FooterM></FooterM>
  </div>
</template>

<script>
import BScroll from "@better-scroll/core";
import NestedScroll from "@better-scroll/nested-scroll";
import NavBarM from "../../components/NavBarM.vue";
import FooterM from "../../components/FooterM.vue";
BScroll.use(NestedScroll);
export default {
  components: {
    FooterM,
    NavBarM,
  },
  data() {
    return {
      bScroll: null,
    };
  },
  methods: {
    jump(index) {
      this.$emit("jump", index);
    },
  },
  mounted() {
    this.bScroll = new BScroll(this.$refs.content, {
      scrollY: true,
      scrollX: false,
      bounce: false,
      probeType: 3,
      click: true,
      nestedScroll: {
        groupId: "asdf",
      },
    });
    this.bScroll.on("beforeScrollStart", () => {
      this.$refs.navbar.hidden();
    });
  },
};
</script>

<style scoped>
img {
  width: 2rem;
}
/deep/ .el-collapse-item__arrow {
  display: none;
}
.slide-page {
  font-size: 11.2rem;
}
</style>
